var map = {
	"./canvas-example.jpg": 1410,
	"./mongsoon-results/1.jpg": 6448,
	"./mongsoon-results/10.jpg": 5469,
	"./mongsoon-results/11.jpg": 7790,
	"./mongsoon-results/12.jpg": 1647,
	"./mongsoon-results/13.jpg": 2406,
	"./mongsoon-results/14.jpg": 8834,
	"./mongsoon-results/15.jpg": 1244,
	"./mongsoon-results/16.jpg": 2229,
	"./mongsoon-results/17.jpg": 1961,
	"./mongsoon-results/18.jpg": 7067,
	"./mongsoon-results/19.jpg": 9654,
	"./mongsoon-results/2.jpg": 7125,
	"./mongsoon-results/20.jpg": 1636,
	"./mongsoon-results/21.jpg": 6039,
	"./mongsoon-results/22.jpg": 1874,
	"./mongsoon-results/23.jpg": 5892,
	"./mongsoon-results/24.jpg": 1402,
	"./mongsoon-results/25.jpg": 8781,
	"./mongsoon-results/26.jpg": 9872,
	"./mongsoon-results/27.jpg": 1295,
	"./mongsoon-results/28.jpg": 8277,
	"./mongsoon-results/29.jpg": 2739,
	"./mongsoon-results/3.jpg": 8090,
	"./mongsoon-results/30.jpg": 624,
	"./mongsoon-results/31.jpg": 3158,
	"./mongsoon-results/32.jpg": 3988,
	"./mongsoon-results/33.jpg": 1110,
	"./mongsoon-results/34.jpg": 2850,
	"./mongsoon-results/35.jpg": 3925,
	"./mongsoon-results/36.jpg": 888,
	"./mongsoon-results/37.jpg": 1144,
	"./mongsoon-results/38.jpg": 4524,
	"./mongsoon-results/39.jpg": 959,
	"./mongsoon-results/4.jpg": 3282,
	"./mongsoon-results/40.jpg": 6121,
	"./mongsoon-results/41.jpg": 4956,
	"./mongsoon-results/42.jpg": 9438,
	"./mongsoon-results/43.jpg": 1383,
	"./mongsoon-results/44.jpg": 1204,
	"./mongsoon-results/45.jpg": 7933,
	"./mongsoon-results/46.jpg": 4733,
	"./mongsoon-results/47.jpg": 7547,
	"./mongsoon-results/48.jpg": 6862,
	"./mongsoon-results/49.jpg": 420,
	"./mongsoon-results/5.jpg": 1481,
	"./mongsoon-results/50.jpg": 9179,
	"./mongsoon-results/51.jpg": 5707,
	"./mongsoon-results/52.jpg": 3393,
	"./mongsoon-results/53.jpg": 6757,
	"./mongsoon-results/54.jpg": 7452,
	"./mongsoon-results/55.jpg": 4650,
	"./mongsoon-results/56.jpg": 5006,
	"./mongsoon-results/57.jpg": 8694,
	"./mongsoon-results/58.jpg": 7006,
	"./mongsoon-results/59.jpg": 3108,
	"./mongsoon-results/6.jpg": 7916,
	"./mongsoon-results/60.jpg": 1560,
	"./mongsoon-results/7.jpg": 1781,
	"./mongsoon-results/8.jpg": 3509,
	"./mongsoon-results/9.jpg": 1823,
	"./ray-results/1.jpg": 9168,
	"./ray-results/10.jpg": 942,
	"./ray-results/11.jpg": 7598,
	"./ray-results/12.jpg": 8609,
	"./ray-results/13.jpg": 9282,
	"./ray-results/14.jpg": 734,
	"./ray-results/15.jpg": 5616,
	"./ray-results/16.jpg": 2035,
	"./ray-results/17.jpg": 7920,
	"./ray-results/18.jpg": 7974,
	"./ray-results/19.jpg": 9170,
	"./ray-results/2.jpg": 6172,
	"./ray-results/20.jpg": 4412,
	"./ray-results/21.jpg": 201,
	"./ray-results/22.jpg": 1502,
	"./ray-results/23.jpg": 8003,
	"./ray-results/24.jpg": 7880,
	"./ray-results/25.jpg": 2613,
	"./ray-results/26.jpg": 1425,
	"./ray-results/27.jpg": 9056,
	"./ray-results/28.jpg": 9393,
	"./ray-results/29.jpg": 973,
	"./ray-results/3.jpg": 9199,
	"./ray-results/30.jpg": 2716,
	"./ray-results/31.jpg": 6450,
	"./ray-results/32.jpg": 1558,
	"./ray-results/33.jpg": 121,
	"./ray-results/34.jpg": 4291,
	"./ray-results/35.jpg": 8047,
	"./ray-results/36.jpg": 6933,
	"./ray-results/37.jpg": 4326,
	"./ray-results/38.jpg": 6493,
	"./ray-results/39.jpg": 725,
	"./ray-results/4.jpg": 5710,
	"./ray-results/40.jpg": 9335,
	"./ray-results/41.jpg": 448,
	"./ray-results/42.jpg": 5627,
	"./ray-results/43.jpg": 4332,
	"./ray-results/44.jpg": 8476,
	"./ray-results/45.jpg": 7873,
	"./ray-results/46.jpg": 3061,
	"./ray-results/47.jpg": 2539,
	"./ray-results/48.jpg": 7883,
	"./ray-results/49.jpg": 4597,
	"./ray-results/5.jpg": 9389,
	"./ray-results/50.jpg": 6545,
	"./ray-results/51.jpg": 7181,
	"./ray-results/52.jpg": 4414,
	"./ray-results/53.jpg": 5493,
	"./ray-results/54.jpg": 2855,
	"./ray-results/55.jpg": 3123,
	"./ray-results/56.jpg": 5498,
	"./ray-results/57.jpg": 1388,
	"./ray-results/58.jpg": 9187,
	"./ray-results/59.jpg": 1922,
	"./ray-results/6.jpg": 1178,
	"./ray-results/60.jpg": 1069,
	"./ray-results/7.jpg": 1827,
	"./ray-results/8.jpg": 7552,
	"./ray-results/9.jpg": 6052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;